// Components
import Loading from './Loading';
import ErrorNoToken from './ErrorNoToken';
import ErrorTokenExpired from './ErrorTokenExpired';
import ErrorUndefined from './ErrorUndefined';
import ErrorInsufficientFunds from './ErrorInsufficientFunds';

// Constants
import {
    ERROR_GENERIC,
    ERROR_EXPIRED_TOKEN,
    ERROR_INVALID_TOKEN,
    ERROR_INSUFFICIENT_FUNDS,
} from '../../../utils/constants/constants';

/**
 * @function StateHandler
 * Describes a list of available game sessions
 *
 * @example
 * return (
 *   <StateHandler state='' error='' loadingText='' />
 * )
 */
function StateHandler({
    status,
    error,
    loadingText,
}: StateHandlerProps): JSX.Element {
    if (status === 'failed') {
        switch (error) {
            case ERROR_INVALID_TOKEN:
                return <ErrorNoToken />;
            case ERROR_EXPIRED_TOKEN:
                return <ErrorTokenExpired />;
            case ERROR_INSUFFICIENT_FUNDS:
                return <ErrorInsufficientFunds />;
            default:
                return <ErrorUndefined error={ERROR_GENERIC} />;
        }
    }

    return <Loading text={loadingText} />;
}

/**
 * @interface StateHandlerProps
 * Describes the properties required for the LobbyGrid component
 *
 * @property {string} status Data fetching status of the slice
 * @property {string} error Current error reported by the slice
 * @property {string} loadingText Text to display when the status is in loading
 */
export interface StateHandlerProps {
    status: string;
    error: string;
    loadingText: string;
}

// Exports
export default StateHandler;
